var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconParty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2015 6.63247C11.6173 5.24273 11.578 2.9651 11.3813 2M13.1511 10.6859C13.741 8.36965 15.7882 9.46834 17.2806 8.36965C19.6403 6.63247 16.1007 4.31624 19.6403 3.73718M16.6907 13.5812C18.4604 13.0021 20.8201 13.5812 22 14.7393M4.1501 12.9935L10.1755 18.9079M10.1755 18.9079L2.62629 21.9121C1.66009 22.2965 0.697897 21.3521 1.0896 20.4037L4.1501 12.9935L5.14675 10.5804C5.4641 9.81202 6.47717 9.61031 7.07445 10.1966L13.0249 16.0375C13.6222 16.6237 13.4167 17.6181 12.6339 17.9296L10.1755 18.9079ZM7.25183 4.31624C7.25183 4.95585 6.72359 5.47435 6.07197 5.47435C5.42036 5.47435 4.89212 4.95585 4.89212 4.31624C4.89212 3.67662 5.42036 3.15812 6.07197 3.15812C6.72359 3.15812 7.25183 3.67662 7.25183 4.31624ZM21.4101 19.3718C21.4101 20.0114 20.8818 20.5299 20.2302 20.5299C19.5786 20.5299 19.0504 20.0114 19.0504 19.3718C19.0504 18.7322 19.5786 18.2137 20.2302 18.2137C20.8818 18.2137 21.4101 18.7322 21.4101 19.3718Z",
    stroke: "#00A886",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParty);
export default __webpack_public_path__ + "static/media/icon-party.34245356778b3eb4d93e4ee1698d897e.svg";
export { ForwardRef as ReactComponent };